module.exports = __webpack_public_path__ + "static/media/shape3.3a43746a.svg";